export enum Amount {
  TWO_HUNDRED_THOUSAND = 200000,
  ONE_MILLION = 1000000,
  TWO_MILLION = 2000000,
}